import { render, staticRenderFns } from "./Huanzhejiaohoa.vue?vue&type=template&id=52e55b09&scoped=true"
import script from "./Huanzhejiaohoa.vue?vue&type=script&lang=js"
export * from "./Huanzhejiaohoa.vue?vue&type=script&lang=js"
import style0 from "./Huanzhejiaohoa.vue?vue&type=style&index=0&id=52e55b09&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e55b09",
  null
  
)

export default component.exports